import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import { styled } from "@mui/material/styles";

const RedAsterisk = styled("span")({
  color: "red",
});

const CustomTextField = ({
  id,
  label,
  name,
  autoComplete,
  autoFocus,
  endAdornmentIcon: EndAdornmentIcon,
  formik,
  type = "text",
  multiLine = false,
  placeholder,
  numberFlag = false,
  isHeight = "40px",
  required = true,
  ...props
}) => {
  const handleKeyPress = (event) => {
    if (numberFlag && !/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    const hasLeadingSpace = /^\s/.test(inputValue);
    if (!hasLeadingSpace) {
      formik?.handleChange(e);
    }
  };

  return (
    <TextField
      variant="outlined"
      margin="normal"
      required={required}
      fullWidth
      type={type}
      id={id}
      label={label}
      name={name}
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      placeholder={placeholder}
      value={formik?.values[name]}
      onChange={handleChange}
      onBlur={formik?.handleBlur}
      error={formik?.touched[name] && Boolean(formik?.errors[name])}
      helperText={
        formik?.touched[name] && formik?.errors[name] ? formik.errors[name] : ""
      }
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            {EndAdornmentIcon && (
              <EndAdornmentIcon style={{ fontSize: "18px" }} />
            )}
          </InputAdornment>
        ),
        style: {
          fontWeight: 300,
          height: multiLine ? "" : isHeight,
          fontFamily: "Urbane-Light",
        },
        inputProps: {
          style: {
            padding: "8px 14px",
            fontSize: "12px",
          },
          inputMode: numberFlag ? "numeric" : undefined,
          pattern: numberFlag ? "[0-9]*" : undefined,
        },
      }}
      {...props}
    />
  );
};

export default CustomTextField;
